import React, { useEffect } from 'react';
import { WorkflowDetailComponent } from '@admin/shared';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { workflowActions } from '@admin/core';

const WorkflowDetail = () => {
  const { id }: { id: string } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(workflowActions.getWorkflowRequest(id));
      dispatch(workflowActions.getWorkflowStagesRequest(id));
    }
  }, [id, dispatch]);

  return <WorkflowDetailComponent />;
};

export { WorkflowDetail };
